import React from 'react'
import { MdClose } from 'react-icons/md'
import styles from './CourseActionWrapper.module.css'
import CourseLeadPrimaryQuestionnaire from './CourseLeadPrimaryQuestionnaire'

const CourseActionWrapper = props => {
    const { isOpen, abortActionCreation, initiateProfileCreation, updateLeadAction, leadIdentifier } = props

    if (!isOpen) {
        return null
    }
    return (
        <div className={styles.mainWrapper}>
            <div className={styles.mainContainer} id="leadProfileCreationContainer"
                style={{ animation: `0.1s cubic-bezier(0, 0.63, 0.26, 0.96) 0s 1 normal forwards running slideBottomToTop` }}
            >
                <div className={styles.closeBtn}>
                    <button onClick={() => abortActionCreation()}><MdClose size={24} /></button>
                </div>

                <div className={styles.creationForm}>
                    <CourseLeadPrimaryQuestionnaire
                        abortActionCreation={abortActionCreation}
                        initiateProfileCreation={initiateProfileCreation}
                        updateLeadAction={updateLeadAction}
                        leadIdentifier={leadIdentifier}
                    />
                </div>
            </div>
        </div>
    )
}

export default CourseActionWrapper